import React, { useEffect, useState } from 'react'
import TopImage from '../../Assets/images/listing-bnr.webp'
import { ApiConstants } from '../../constants/ApiConstants'
import useMakeRequest from '../../utils/ApiHelper'
import { Link } from 'react-router-dom'
import { PAGINATION } from '../../constants/Constants'
import { encodeID } from '../../utils/Helper'
import { useNavigate } from 'react-router-dom'
import FrontLoader from '../layout/FrontLoader'
import { LanguageConstants } from '../../constants/LanguageConstants'
import proImg from '../../Assets/images/pro-img.png'
import awardIcon from '../../Assets/images/award.svg';

function Product() {
const [data , setData]=useState([])
const product = useMakeRequest()
const navigate = useNavigate()
const [pagination , setPagination] = useState({page:PAGINATION.PAGE || 0  , pageSize:PAGINATION.PAGESIZE || 10})
  useEffect(()=>{
    const payload ={
    "page":pagination?.page,
    "pageSize":pagination?.pageSize
    }
    product.makeRequest({ payload, url: ApiConstants?.Productlist, toastStatus: false })
  },[pagination])
  useEffect(()=>{
 if(product.status){
  setData(product?.data?.data?.rows)
 }
  },[product?.status])
  useEffect(() => {
    if(product?.data?.data?.count >= 8  && pagination?.pageSize < product?.data?.data?.count){
    const handleScroll = () => {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          pageSize: prevPagination.pageSize < 20 ? 20 : prevPagination.pageSize, 
        }));
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }
  }, [pagination]);

 const navigatToProductdetailPage =(e:any)=>{
  return navigate(`/productdetail/${encodeID(e?.id)}`)
 } 

  return (
    <>
    {product.loading ? <FrontLoader/> : null}
    <main>

    {/* top banner section end  */}
    <div className="head-space">
        <div className="footer-space">
            <div className="container">
              <h1 className='sec-ttl my-4 text-capitalize'>Trending Products</h1>
                <div className="row g-4">
                  {data.length > 0 ? data.map((res:any , i:any)=>(

                    <div className="col-sm-6 col-md-4" onClick={()=>navigatToProductdetailPage(res)}  key={i}>
                    <div className="pro-sugg-single">
                        <div className="pro-sugg-img">
                            <span className="pro-sugg-badge">
                              <img src={awardIcon}/>
                              <span>Most Popular</span>
                            </span>
                            <img src={res?.product_image_details?.file_path} alt="product" />
                        </div>
                        <div className="pro-sugg-ct">
                            <h3 className="pro-sugg-ttl">{res?.product_details?.name}</h3>
                            <p className="pro-sugg-para">{res?.product_details?.description}</p>
                        </div>
                    </div>
                    </div>
                  )):<p className='mt-5 text-center'>{LanguageConstants?.DATANOTFOUND}</p>}
                  
                  </div>

            </div>
        </div>
    </div>

</main>
</>
  )
}

export default Product